import React, { useEffect, useState, useRef } from "react";
import "react-table-v6/react-table.css";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import {
  Col,
  Container,
  Form,
  FormControl,
  Nav,
  Row,
  Tab,
  Table,
} from "react-bootstrap";
import Footer from "../commonAdmin/Footer";
import Loader from "../../common/Loader";

import {
  Link,
  useHistory,
  useLocation,
  useNavigate,
} from "react-router-dom/cjs/react-router-dom.min";
import delivaApiService from "../../../common/services/apiService";

import { ReactComponent as Copy } from "./../../../assets/images/icons/copy.svg";
import { ReactComponent as Edit } from "./../../../assets/images/icons/edit.svg";
import { ReactComponent as Alert } from "./../../../assets/images/icons/alert.svg";
import NotificationSetting from "./NotificationSetting";
import NotificationSettingPromo from "./NotificationSetttingPromo";
import { showErrorToast } from "../../../common/helpers/Utils";
import moment from "moment";
import deadline from "../../../assets/images/deadline.svg";

// Add this function to check if a promo is expired
const isExpired = (endDate) => {
  if (!endDate) return false; // Ongoing
  return moment.utc(endDate).local().endOf("day").isBefore(moment());
};

const PromotionReferralList = (props) => {
  // hooks
  const history = useHistory();
  const location = useLocation();

  // state management
  const [loading, setLoading] = useState(false);
  const [allReferral, setAllReferral] = useState();
  const [allPromo, setAllPromo] = useState();
  const [allNotificationType, setAllNotificationType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPromoModalOpen, setIsPromoModalOpen] = useState(false);
  const [selectedReferralID, setSelectedReferralID] = useState();
  const [selectedPromoID, setSelectedPromoID] = useState();
  const [pageno, setPageno] = useState({ promotion: 1, referral: 1 });
  const [totalPage, setTotalPage] = useState({ promotion: 0, referral: 0 });
  const [pageArray, setPageArray] = useState({ promotion: [], referral: [] });
  const [records, setRecords] = useState({ promotion: 10, referral: 10 });
  const [inputRecords, setInputRecords] = useState({ promotion: 10, referral: 10 });
  const [sortBy, setSortBy] = useState({ promotion: "", referral: "" });
  const [sortOrder, setSortOrder] = useState({ promotion: "", referral: "" });
  const [orderBy, setOrderBy] = useState({ promotion: "", referral: "" });
  const [totalRecords, setTotalRecords] = useState("");
  const [searchText, setSearchText] = useState({ promotion: "", referral: "" });
  const [searchValue, setSearchValue] = useState({
    promotion: "",
    referral: "",
  });
  const [activeTab, setActiveTab] = useState("promotion");
  const [disabledItems, setDisabledItems] = useState({
    promotion: [],
    referral: [],
  });
  const [filterList, setFilterList] = useState("LOCAL_DELIVERY");

  useEffect(() => {
    localStorage.setItem("isEdited", "true");
    let state = location.state || {};
    const tab = state.tab || "promotion";
    const isEdited = JSON.parse(localStorage.getItem("isEdited") || "false");
    const savedPageno = JSON.parse(localStorage.getItem("pageno") || "{}");
    const referralPage = savedPageno?.referral ?? 1;
    const nextPage = { promotion: 1, referral: 1 };

    // Coming from referral edit, copy and add
    if ((isEdited && tab === "referral") || referralPage !== 1) {
      setActiveTab("referral");
      setPageno({ ...nextPage, referral: 1 });
      localStorage.setItem("activeTab", "referral");
      localStorage.setItem(
        "pageno",
        JSON.stringify({ ...nextPage, referral: 1 }),
      );
      history.replace({ ...location, state: {} });
      return;
    }

    const savedTab = localStorage.getItem("activeTab") || "promotion";

    if (!isEdited && savedTab === "referral" && referralPage === 1) {
      setActiveTab("promotion");
      setPageno({ ...nextPage });
      localStorage.setItem("activeTab", "promotion");
      localStorage.setItem("pageno", JSON.stringify(nextPage));
      return;
    }

    // Default: promotion tab, page 1
    localStorage.setItem("activeTab", "promotion");
    localStorage.setItem("pageno", JSON.stringify(nextPage));
  }, [location, history]);

  // Save tab to localStorage on change
  const handleTabSelect = (k) => {
    setActiveTab(k);
    localStorage.setItem("activeTab", k);
    setPageno((prev) => ({ ...prev, [k]: 1 }));
    localStorage.setItem("pageno", JSON.stringify({ ...pageno, [k]: 1 }));
  };

  // Function to open the modal
  const handleOpenModal = () => {
    activeTab === "promotion"
      ? setIsPromoModalOpen(true)
      : setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    activeTab === "promotion"
      ? setIsPromoModalOpen(false)
      : setIsModalOpen(false);
  };

  // Prepare pagination array as per available records
  const generatePageArray = (totalPages, currentPage) => {
    let startPage, endPage;
    switch (true) {
      case totalPages <= 5:
        startPage = 1;
        endPage = totalPages;
        break;

      case currentPage <= 3:
        startPage = 1;
        endPage = 5;
        break;

      case currentPage + 1 >= totalPages:
        startPage = totalPages - 4;
        endPage = totalPages;
        break;

      default:
        startPage = currentPage - 2;
        endPage = currentPage + 2;
        break;
    }
    const pageArray = [];
    for (let i = startPage; i <= endPage; i++) {
      pageArray.push(i);
    }
    return pageArray;
  };

  // Manage switch pages through Pagination
  const onChangePage = (page) => {
    setPageno((prev) => ({ ...prev, [activeTab]: page }));
    setPageArray((prev) => ({
      ...prev,
      [activeTab]: generatePageArray(totalPage[activeTab], page),
    }));
    localStorage.setItem(
      "pageno",
      JSON.stringify({ ...pageno, [activeTab]: page }),
    );
  };

  // Set No. of records per page
  const onChangeItemPerPage = (e) => {
    const rawValue = e.target.value;
    if (rawValue === "" || /^[1-9][0-9]*$/.test(rawValue)) {
      setInputRecords((prev) => ({ ...prev, [activeTab]: rawValue }));
    }
  };

  const onEnterPerPage = (e) => {
    if (e.key === 'Enter') {
      const val = inputRecords[activeTab];
      if (val && val > 0) {
        setRecords((prev) => ({ ...prev, [activeTab]: val }));
        setPageno((prev) => ({ ...prev, [activeTab]: 1 }));
        localStorage.setItem("pageno", JSON.stringify({ ...pageno, [activeTab]: 1 }));
      }
    }
  };

  // ASC/DESC Sorting

  const handleSortChange = (column) => {
    setOrderBy((prev) => ({
      ...prev,
      [activeTab]: prev[activeTab] === column ? prev[activeTab] : column,
    }));
    setSortOrder((prev) => ({
      ...prev,
      [activeTab]:
        orderBy[activeTab] === column
          ? prev[activeTab] === "ASC"
            ? "DESC"
            : "ASC"
          : "ASC", // First click: DESC
    }));
  };

  // Triggered on input change
  const getSearchData = (e) => {
    let value = e.target.value;
    let trimmedValue = value.replace(/\s+/g, " ").trim();
    if (value.length === 0) {
      setSearchText((prev) => ({ ...prev, [activeTab]: "" }));
      setSearchValue((prev) => ({ ...prev, [activeTab]: "" }));
    } else {
      setSearchText((prev) => ({ ...prev, [activeTab]: trimmedValue }));
      setSearchValue((prev) => ({ ...prev, [activeTab]: trimmedValue }));
    }
  };

  //useEffect to watch for searchText[activeTab] becoming empty and call getReferralPromoData
  useEffect(() => {
    if (searchText[activeTab] === "") {
      getReferralPromoData("", activeTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText[activeTab], activeTab, filterList]);

  const handleSearch = () => {
    const trimmedText = searchText[activeTab].trim();
    if (trimmedText.length < 2) {
      return;
    }
    setSearchValue((prev) => ({ ...prev, [activeTab]: trimmedText }));
    setPageno((prev) => ({ ...prev, [activeTab]: 1 })); // Move to first page on search
    // getReferralPromoData will be triggered by useEffect watching pageno
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // API for active/inactive switch
  // const handleSwitchChange = async (item, isActive) => {
  //   let refPayload = {
  //     referralId: item?.referralId,
  //     active: isActive,
  //     type: activeTab,
  //   };

  //   let proPayload = {
  //     promoId: item?.promoId,
  //     active: isActive,
  //     type: activeTab,
  //   };

  //   const isPromotion = activeTab === 'promotion';
  //   const payload = isPromotion ? proPayload : refPayload;
  //   const endPoint = isPromotion ? 'activeInactivePromo' : 'activeInactive';

  //   await delivaApiService(endPoint, payload)
  //     .then((response) => {
  //       if (response?.data?.status === 200) {
  //         setSelectedReferralID(item);
  //         setSelectedPromoID(item);
  //         getReferralPromoData();
  //         if (!item?.active && item?.notificationEnable === false) {
  //           handleOpenModal();
  //         }
  //         console.log('isActive...', item.active);
  //       } else if (response?.data?.status === 400) {
  //         if (activeTab !== 'promotion') {
  //           if (item?.roleId === 2) {
  //             showErrorToast('One Referral is Already Activated for Sender.');
  //           } else if (item?.roleId === 3) {
  //             showErrorToast(
  //               'One Referral is Already Activated for Delivery Partner.'
  //             );
  //           }
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Failed to update status:', error);
  //     });
  // };

  const handleSwitchChange = async (item, isActive) => {
    const id = activeTab === "promotion" ? item?.promoId : item?.referralId;

    // Optimistically disable editing right away
    addDisabledItem(activeTab, id);

    const isPromotion = activeTab === "promotion";
    const payload = isPromotion
      ? { promoId: item?.promoId, active: isActive, type: activeTab }
      : { referralId: item?.referralId, active: isActive, type: activeTab };
    const endPoint = isPromotion ? "activeInactivePromo" : "activeInactive";

    try {
      const response = await delivaApiService(endPoint, payload);

      if (response?.data?.status === 200) {
        setSelectedReferralID(item);
        setSelectedPromoID(item);
        getReferralPromoData(); // refresh list
        if (!item?.active && item?.notificationEnable === false) {
          handleOpenModal();
        }
        // NOTE: we intentionally keep the item in disabledItems so edit stays disabled after toggle
      } else {
        // server returned error: rollback
        removeDisabledItem(activeTab, id);

        if (response?.data?.status === 400) {
          if (activeTab !== "promotion") {
            if (item?.roleId === 2) {
              showErrorToast("One Referral is Already Activated for Sender.");
            } else if (item?.roleId === 3) {
              showErrorToast(
                "One Referral is Already Activated for Delivery Partner.",
              );
            }
          }
        } else {
          showErrorToast("Failed to update status.");
        }
      }
    } catch (error) {
      // network error: rollback
      removeDisabledItem(activeTab, id);
      console.error("Failed to update status:", error);
      showErrorToast("Network error updating status. Please try again.");
    }
  };

  // API for get all REFERRAL and PROMO LIST
  const getReferralPromoData = async (searchVal = "", tabOverride) => {
    try {
      setLoading(true);
      const tabKey = tabOverride || activeTab;
      const payload = {
        page: pageno[tabKey],
        size: records[tabKey],
        deliveryType: filterList !== "all-routes" ? filterList : "",
        searchKey: searchVal !== "" ? searchVal : searchValue[tabKey] || "",
      };
      if (orderBy[tabKey]) payload.orderBy = orderBy[tabKey];
      if (sortOrder[tabKey]) payload.sortDirection = sortOrder[tabKey];
      if (tabKey === "referral") {
        const [referralData] = await Promise.all([
          delivaApiService("getAllReferral", payload),
        ]);
        if (referralData?.status === 200) {
          let data = referralData.data?.resourceData;
          setAllReferral(data);
          const totalRecords = referralData.data?.totalRecords;
          const totalPages = Math.ceil(totalRecords / records[tabKey]);
          setTotalPage((prev) => ({ ...prev, referral: totalPages }));
          setPageArray((prev) => ({
            ...prev,
            referral: generatePageArray(totalPages, pageno[tabKey]),
          }));
          setLoading(false);
          setTotalRecords(totalRecords);
        }
      } else if (tabKey === "promotion") {
        const [promoData] = await Promise.all([
          delivaApiService("getAllPromo", payload),
        ]);
        if (promoData?.status === 200) {
          let data = promoData.data?.resourceData;
          setAllPromo(data);
          const totalRecords = promoData.data?.totalRecords;
          const totalPages = Math.ceil(totalRecords / records[tabKey]);
          setTotalPage((prev) => ({ ...prev, promotion: totalPages }));
          setPageArray((prev) => ({
            ...prev,
            promotion: generatePageArray(totalPages, pageno[tabKey]),
          }));
          setLoading(false);
          setTotalRecords(totalRecords);
        }
      }
    } catch (error) {
      console.error("Error fetching referral-promotion data:", error);
    } finally {
      setLoading(false);
    }
  };

  const convertToLocalDate = (dateString) => {
    if (!dateString) return "--";
    return moment.utc(dateString).local().format("DD MMM YYYY"); // e.g. 15 Jul 2025
  };

  const addDisabledItem = (tab, id) => {
    setDisabledItems((prev) => {
      const newArr = Array.from(new Set([...(prev[tab] || []), id]));
      const next = { ...prev, [tab]: newArr };
      localStorage.setItem("disabledItems", JSON.stringify(next)); // save to storage
      return next;
    });
  };

  const removeDisabledItem = (tab, id) => {
    setDisabledItems((prev) => {
      const next = {
        ...prev,
        [tab]: (prev[tab] || []).filter((i) => i !== id),
      };
      localStorage.setItem("disabledItems", JSON.stringify(next)); // save to storage
      return next;
    });
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("disabledItems") || "{}");
    setDisabledItems({
      promotion: saved.promotion || [],
      referral: saved.referral || [],
    });
  }, []);

  useEffect(() => {
    getReferralPromoData("", activeTab);
  }, [pageno, records, orderBy[activeTab], sortOrder[activeTab], activeTab]);

  useEffect(() => {
    // Persist pageno to localStorage whenever it changes
    localStorage.setItem("pageno", JSON.stringify(pageno));
  }, [pageno]);

  const handleFilterChange = (value) => {
    setFilterList(value);
  };
  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <div className="page-header mb-3">
                  <div>
                    <h3 className="font-weight-normal mb-0 line-ht fs-24 color-33 text-nowrap">
                      List of Promotion & Referral{" "}
                      <span className="color-grey">({totalRecords})</span>
                    </h3>
                  </div>
                  <div className="page-search d-flex justify-content-between justify-content-lg-end gap-3 w-100">
                    <div className="d-flex gap-3">
                      <div className="mxw-90">
                        <FormControl
                          type="text"
                          placeholder="Search by code"
                          className="searchTxt mb-3 mb-lg-0"
                          value={searchText[activeTab] || ""}
                          onChange={(e) => getSearchData(e)}
                          onKeyDown={(e) => handleKeyDown(e)}
                        />
                        <span
                          onClick={handleSearch}
                          className="icon-search pointer"
                        ></span>
                      </div>
                      <Form>
                        <Form.Group controlId="formBasicEmail" className="mb-0">
                          <Form.Control
                            className="login-input select-rounded text-capitalize"
                            as="select"
                            custom
                            name="filterList"
                            value={filterList}
                            onChange={(e) => handleFilterChange(e.target.value)}
                            // disabled
                          >
                            <option value="all-routes">All Route</option>
                            <option value="LOCAL_DELIVERY">Local</option>
                            <option value="INTERSTATE_DELIVERY">
                              Interstate
                            </option>
                            <option value="INTERNATIONAL_DELIVERY">
                              International
                            </option>
                          </Form.Control>
                        </Form.Group>
                      </Form>
                      <button
                        className="button rounded-pill btnPrimary text-nowrap px-4"
                        onClick={() =>
                          history.push({
                            pathname:
                              activeTab === "promotion"
                                ? "/addPromotion"
                                : "/addReferral",
                            state: {
                              tab: activeTab,
                            },
                          })
                        }
                      >
                        {activeTab === "promotion"
                          ? "Add Promotion"
                          : "Add Referral"}
                      </button>
                    </div>
                  </div>
                </div>
                <Tab.Container
                  activeKey={activeTab}
                  onSelect={(k) => handleTabSelect(k)}
                >
                  <Nav className="custom-tabs">
                    <Nav.Item>
                      <Nav.Link eventKey="promotion">Promotion</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="referral">Referral</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="promotion">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th></th>
                            <th>#</th>
                            {/* <th>User Type </th> */}
                            <th>
                              Delivery Type{" "}
                              {/* <Link
                                className="icon-up-and-down color-light-grey"
                                onClick={() =>
                                  handleSortChange('deliveryRequestType')
                                }
                              /> */}
                            </th>
                            <th>
                              User Type{" "}
                              <Link
                                className="icon-up-and-down color-light-grey"
                                onClick={() => handleSortChange("userType")}
                              />{" "}
                            </th>
                            <th>Name of Offer</th>
                            <th>Code</th>
                            <th>Duration of Promo</th>
                            <th>No. of Usage</th>
                            <th>Inactive/Active</th>

                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="ttl-order-table">
                          {allPromo?.length > 0 ? (
                            allPromo.map((ref, index) => (
                              <tr
                                key={"promo" + index}
                                className={
                                  isExpired(ref?.promotionEndDate)
                                    ? "expired-row"
                                    : ""
                                }
                                disabled={!ref?.active || ref?.promotionEndDate}
                              >
                                <td style={{ maxWidth: "25px" }}>
                                  {isExpired(ref?.promotionEndDate) && (
                                    <img
                                      src={deadline}
                                      alt="deadline"
                                      style={{ maxWidth: "20px" }}
                                    />
                                  )}
                                </td>
                                <td>
                                  {(pageno[activeTab] - 1) *
                                    records[activeTab] +
                                    index +
                                    1}
                                </td>

                                <td>
                                  {ref?.deliveryRequestType === "LOCAL_DELIVERY"
                                    ? "Local Delivery"
                                    : ref?.deliveryRequestType
                                      ? ref?.deliveryRequestType
                                          .replace(/_/g, " ")
                                          .toLowerCase()
                                          .replace(/\b\w/g, (char) =>
                                            char.toUpperCase(),
                                          )
                                      : "--"}
                                </td>
                                <td>
                                  {ref?.userType === "delivery_agent"
                                    ? "Delivery Partner"
                                    : "Sender"}
                                </td>
                                <td>
                                  {ref?.offerName ? ref?.offerName : "--"}
                                </td>
                                <td className="text-capitalize">
                                  {ref?.code ? ref?.code : "--"}
                                </td>
                                <td>
                                  {ref?.promotionStartDate
                                    ? convertToLocalDate(
                                        ref?.promotionStartDate,
                                      )
                                    : "--"}{" "}
                                  -{" "}
                                  <span className="d-block">
                                    {ref?.promotionEndDate
                                      ? convertToLocalDate(
                                          ref?.promotionEndDate,
                                        )
                                      : "Ongoing"}
                                  </span>{" "}
                                </td>
                                <td>
                                  {ref?.noOfUsage === 0 ? (
                                    0
                                  ) : (
                                    <Link
                                      className="link"
                                      onClick={() =>
                                        history.push(
                                          `/promoUsage/${ref?.promoId}`,
                                        )
                                      }
                                    >
                                      {ref?.noOfUsage}
                                    </Link>
                                  )}
                                </td>
                                <td>
                                  <Form className="text-center">
                                    <Form.Check
                                      type="switch"
                                      id={`customSwitchPromo${index}`}
                                      label=""
                                      className="custom-switch-green"
                                      checked={
                                        ref.active &&
                                        !isExpired(ref.promotionEndDate)
                                      }
                                      onChange={(e) =>
                                        handleSwitchChange(
                                          ref,
                                          e.target.checked,
                                        )
                                      }
                                      disabled={isExpired(ref.promotionEndDate)}
                                    />
                                  </Form>
                                </td>
                                <td>
                                  <div className="action-buttons d-flex w-100">
                                    <span
                                      className="links pointer"
                                      role="button"
                                      tabIndex={0}
                                      onClick={() =>
                                        history.push(
                                          `/promoDetails/${ref?.promoId}`,
                                        )
                                      }
                                      title="View Details"
                                    >
                                      <i className="icon-eye"></i>
                                    </span>
                                    <span
                                      className="links pointer"
                                      onClick={() =>
                                        history.push({
                                          pathname: `/copyPromotion`,
                                          state: {
                                            tab: activeTab,
                                            id: ref.promoId,
                                            isCopied: true,
                                          },
                                        })
                                      }
                                      role="button"
                                      tabIndex={0}
                                      title="Copy Promo"
                                    >
                                      <Copy />
                                    </span>
                                    <span
                                      onClick={() => {
                                        if (
                                          disabledItems.promotion?.includes(
                                            ref.promoId,
                                          ) ||
                                          !ref?.editable
                                        )
                                          return;
                                        history.push({
                                          pathname: `/editPromotion`,
                                          state: {
                                            tab: activeTab,
                                            id: ref.promoId,
                                          },
                                        });
                                      }}
                                      className={`links pointer ${
                                        disabledItems.promotion?.includes(
                                          ref.promoId,
                                        ) || !ref?.editable
                                          ? "disabled"
                                          : ""
                                      }`}
                                      role="button"
                                      tabIndex={
                                        disabledItems.promotion?.includes(
                                          ref.promoId,
                                        ) || !ref?.editable
                                          ? -1
                                          : 0
                                      }
                                      title={
                                        disabledItems.promotion?.includes(
                                          ref.promoId,
                                        ) || !ref?.editable
                                          ? "Editing disabled after toggling switch"
                                          : "Edit Promo"
                                      }
                                      aria-disabled={
                                        disabledItems.promotion?.includes(
                                          ref.promoId,
                                        ) || !ref?.editable
                                      }
                                    >
                                      <Edit />
                                    </span>

                                    <span
                                      className="links pointer"
                                      role="button"
                                      tabIndex={0}
                                      disabled={!ref.active}
                                      title="Notification Setting"
                                      onClick={() => {
                                        setSelectedPromoID(ref);
                                        handleOpenModal();
                                      }}
                                    >
                                      <Alert />
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="12" className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      {activeTab === "promotion" && allPromo?.length > 0 && (
                        <nav
                          aria-label="Page navigation "
                          className="position-relative"
                        >
                          <ul className="pagination pg-blue deliva-pagination justify-content-end">
                            <li className="page-item">
                              <button
                                className="page-link rotate-180 control-btn"
                                aria-label="Previous"
                                onClick={() =>
                                  onChangePage(pageno[activeTab] - 1)
                                }
                                disabled={pageno[activeTab] === 1}
                                // disabled={!ref?.active}
                              >
                                <span className="icon-next"></span>
                                <span className="sr-only">Previous</span>
                              </button>
                            </li>

                            {pageArray[activeTab]?.map((page, ind) => (
                              <li key={ind} className="page-item">
                                <a
                                  className={`page-link ${
                                    pageno[activeTab] === page ? "active" : ""
                                  }`}
                                  onClick={() => onChangePage(page)}
                                >
                                  {page}
                                </a>
                              </li>
                            ))}

                            <li className="page-item">
                              <button
                                className="page-link control-btn"
                                aria-label="Next"
                                onClick={() =>
                                  onChangePage(pageno[activeTab] + 1)
                                }
                                disabled={
                                  pageno[activeTab] === totalPage[activeTab]
                                }
                              >
                                <span className="icon-next"></span>
                                <span className="sr-only">Next</span>
                              </button>
                            </li>

                            <li className="page-value">
                              Enter Per Page{" "}
                              <input
                                type="text"
                                placeholder="Records"
                                name="records"
                                value={inputRecords[activeTab]}
                                onChange={onChangeItemPerPage}
                                onKeyDown={onEnterPerPage}
                              />
                            </li>
                          </ul>
                        </nav>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="referral">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th></th>
                            <th
                              style={{
                                paddingLeft: "6px",
                              }}
                            >
                              #
                            </th>
                            {/* <th>Refferal ID</th> */}
                            <th>
                              Delivery Type{" "}
                              {/* <Link
                                className="icon-up-and-down color-light-grey"
                                onClick={() =>
                                  handleSortChange('deliveryRequestType')
                                }
                              /> */}
                            </th>
                            <th>
                              User Type{" "}
                              <Link
                                className="icon-up-and-down color-light-grey"
                                onClick={() => handleSortChange("userType")}
                              />
                            </th>
                            <th>Name of Offer</th>
                            <th>Code</th>
                            <th>No. of Usage</th>
                            <th>Inactive/Active</th>

                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="ttl-order-table">
                          {activeTab === "referral" &&
                          allReferral?.length > 0 ? (
                            allReferral.map((ref, index) => (
                              <tr
                                key={"referral" + index}
                                disabled={!ref?.active}
                              >
                                <td></td>
                                <td
                                  style={{
                                    paddingLeft: "6px",
                                  }}
                                >
                                  {(pageno[activeTab] - 1) *
                                    records[activeTab] +
                                    index +
                                    1}
                                </td>
                                {/* <td>{ref?.referralId}</td> */}
                                <td className="text-capitalize">
                                  {ref?.deliveryRequestType === "LOCAL_DELIVERY"
                                    ? "Local Delivery"
                                    : ref?.deliveryRequestType
                                        ?.replace(/_/g, " ")
                                        .toLowerCase()
                                        .replace(/\b\w/g, (char) =>
                                          char.toUpperCase(),
                                        )}
                                </td>
                                <td className="text-capitalize">
                                  {ref?.userType === "delivery_agent"
                                    ? "Delivery Partner"
                                    : "Sender"}
                                </td>
                                <td className="text-capitalize">
                                  {ref?.offerName ? ref?.offerName : "--"}
                                </td>
                                <td className="text-uppercase">
                                  {ref?.code ? ref?.code : "--"}
                                </td>
                                <td>
                                  {ref.noOfUsage === 0 ? (
                                    0
                                  ) : (
                                    <Link
                                      className="link"
                                      onClick={() =>
                                        history.push(
                                          `/referralUsage/${ref.referralId}`,
                                        )
                                      }
                                    >
                                      {ref.noOfUsage}
                                    </Link>
                                  )}
                                </td>
                                <td>
                                  <Form className="text-center">
                                    <Form.Check
                                      type="switch"
                                      id={`customSwitchReferral${index}`}
                                      label=""
                                      className="custom-switch-green"
                                      checked={ref.active}
                                      onChange={(e) =>
                                        handleSwitchChange(
                                          ref,
                                          e.target.checked,
                                        )
                                      }
                                    />
                                  </Form>
                                </td>
                                <td>
                                  <div className="action-buttons d-flex w-100">
                                    <span
                                      className="links pointer"
                                      role="button"
                                      tabIndex={0}
                                      onClick={() =>
                                        history.push(
                                          `/referralDetails/${ref.referralId}`,
                                        )
                                      }
                                      title="View Details"
                                    >
                                      <i className="icon-eye"></i>
                                    </span>
                                    <span
                                      className="links pointer"
                                      onClick={() =>
                                        history.push({
                                          pathname: `/copyRefferal`,
                                          state: {
                                            tab: activeTab,
                                            id: ref.referralId,
                                            isCopied: true,
                                          },
                                        })
                                      }
                                      role="button"
                                      tabIndex={0}
                                      title="Copy Referral"
                                    >
                                      <Copy />
                                    </span>
                                    <span
                                      onClick={() => {
                                        if (
                                          disabledItems.referral?.includes(
                                            ref.referralId,
                                          ) ||
                                          !ref?.editable
                                        )
                                          return;
                                        history.push({
                                          pathname: `/editRefferal`,
                                          state: {
                                            tab: activeTab,
                                            id: ref.referralId,
                                          },
                                        });
                                      }}
                                      className={`links pointer ${
                                        disabledItems.referral?.includes(
                                          ref.referralId,
                                        ) || !ref?.editable
                                          ? "disabled"
                                          : ""
                                      }`}
                                      role="button"
                                      tabIndex={
                                        disabledItems.referral?.includes(
                                          ref.referralId,
                                        ) || !ref?.editable
                                          ? -1
                                          : 0
                                      }
                                      title={
                                        disabledItems.referral?.includes(
                                          ref.referralId,
                                        ) || !ref?.editable
                                          ? "Editing disabled after toggling switch"
                                          : "Edit Referral"
                                      }
                                      aria-disabled={
                                        disabledItems.referral?.includes(
                                          ref.referralId,
                                        ) || !ref?.editable
                                      }
                                    >
                                      <Edit />
                                    </span>

                                    <span
                                      className="links pointer"
                                      role="button"
                                      tabIndex={0}
                                      disabled={!ref.active}
                                      title="Notification Setting"
                                      onClick={() => {
                                        setSelectedReferralID(ref);
                                        handleOpenModal();
                                      }}
                                    >
                                      <Alert />
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="12" className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      {activeTab === "referral" && allReferral?.length > 0 && (
                        <nav
                          aria-label="Page navigation "
                          className="position-relative"
                        >
                          <ul className="pagination pg-blue deliva-pagination justify-content-end">
                            <li className="page-item">
                              <button
                                className="page-link rotate-180 control-btn"
                                aria-label="Previous"
                                onClick={() =>
                                  onChangePage(pageno[activeTab] - 1)
                                }
                                disabled={pageno[activeTab] === 1}
                              >
                                <span className="icon-next"></span>
                                <span className="sr-only">Previous</span>
                              </button>
                            </li>

                            {pageArray[activeTab]?.map((page, ind) => (
                              <li key={ind} className="page-item">
                                <a
                                  className={`page-link ${
                                    pageno[activeTab] === page ? "active" : ""
                                  }`}
                                  onClick={() => onChangePage(page)}
                                >
                                  {page}
                                </a>
                              </li>
                            ))}

                            <li className="page-item">
                              <button
                                className="page-link control-btn"
                                aria-label="Next"
                                onClick={() =>
                                  onChangePage(pageno[activeTab] + 1)
                                }
                                disabled={
                                  pageno[activeTab] === totalPage[activeTab]
                                }
                              >
                                <span className="icon-next"></span>
                                <span className="sr-only">Next</span>
                              </button>
                            </li>

                            <li className="page-value">
                              Enter Per Page{" "}
                              <input
                                type="text"
                                placeholder="Records"
                                name="records"
                                value={inputRecords[activeTab]}
                                onChange={onChangeItemPerPage}
                                onKeyDown={onEnterPerPage}
                              />
                            </li>
                          </ul>
                        </nav>
                      )}
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </Container>
            {/* --- Conditional Rendering in the return statement --- */}
            {isModalOpen && (
              <NotificationSetting
                refferalId={selectedReferralID?.referralId}
                type={activeTab}
                onClose={handleCloseModal}
                onHide={handleCloseModal}
              />
            )}
            {isPromoModalOpen && (
              <NotificationSettingPromo
                promoId={selectedPromoID?.promoId}
                type={activeTab}
                onClose={handleCloseModal}
                onHide={handleCloseModal}
              />
            )}
            <Footer {...props} />
          </Col>
        </Row>
      </div>
      <Loader showLoader={loading} />
    </div>
  );
};
export default PromotionReferralList;
